/// Get the version of the web component to load from the version.json file.
function getWebComponentVersion(versionPath, locale, isES5 = false) {
    const req = new XMLHttpRequest();
    const url = versionPath;

    req.open("GET", url, false);
    req.setRequestHeader('Cache-Control', 'no-cache'); // Never cache this request
    req.send();

    return JSON.parse(req.responseText)[`${locale}-${ isES5? 'es5' : 'es2015'}`];
}



